<template>
    <div>
        <div>
            <md-card style="margin-bottom: 15px">
                <md-card-header>
                    <div class="md-layout">
                        <div class="md-layout-item">
                            <h1 class="md-title">Inventory</h1>
                        </div>

                        <div class="md-layout-item" style="text-align-last: right">
                            <md-button class="md-fab md-mini md-primary" @click="showCreateNewInventory">
                                <md-icon>add</md-icon>
                            </md-button>
                        </div>
                    </div>
                    <div>
                        <md-field>
                            <!--                            <md-input-->
                            <!--                                v-model="inventorySearchFilter.product_name"-->
                            <!--                                placeholder="Zoek op product naam..."-->
                            <!--                                type="text"-->
                            <!--                                v-debounce:300ms="searchInventory"-->
                            <!--                            />-->
                            <product-search-modal
                                @set-selected-product="searchInventory(false, $event)"
                                @reset-search="searchInventory(true)"
                                style="padding-left: 15px; z-index: 2000; width: 95%"
                            >
                            </product-search-modal>
                        </md-field>
                    </div>
                </md-card-header>
            </md-card>
        </div>

        <div>
            <md-card
                v-for="inventory in inventoryList"
                :key="inventory.inventory_id"
                style="margin-bottom: 15px; cursor: pointer; z-index: 0"
            >
                <md-card-header>
                    <div class="md-layout md-gutter md-alignment-top-right">
                        <div class="md-layout-item">
                            <div class="md-subheading md-layout-item md-layout">
                                <b>{{ inventory.product.name }}</b>

                                <!--                                <div>-->
                                <!--                                    <md-icon v-if="!inventory.showDetail">expand_more</md-icon>-->
                                <!--                                    <md-icon v-if="inventory.showDetail">expand_less</md-icon>-->
                                <!--                                </div>-->
                            </div>

                            <div class="md-subhead">
                                {{
                                    inventory.quantity_on_hand
                                        ? 'Aantal ' +
                                          '(' +
                                          inventory.product.pricing.unit_amount +
                                          ' ' +
                                          inventory.product.pricing.unit_type +
                                          ') :' +
                                          inventory.quantity_on_hand
                                        : 'geen stock'
                                }}
                                <!--                                <span>Stock: {{ inventory.quantity_on_hand }} </span>-->
                            </div>
                            <div class="md-subhead">
                                {{
                                    inventory.location ? 'Locatie: ' + inventory.location.location_name : 'Geen locatie'
                                }}
                                <!--                                <span>Stock: {{ inventory.quantity_on_hand }} </span>-->
                            </div>
                        </div>

                        <div class="md-layout-item" style="text-align: right; max-width: 170px">
                            <md-button
                                @click="showIncreaseInvMode(inventory.inventory_id)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon
                                    style="
                                        font-weight: bold;
                                        color: white;
                                        background-color: green;
                                        border-radius: 50%;
                                        padding: 10px;
                                        display: inline-flex;
                                        align-items: center;
                                        justify-content: center;
                                    "
                                    >add</md-icon
                                >
                            </md-button>
                            <md-button
                                @click="showDecreaseInvMode(inventory.inventory_id)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon
                                    style="
                                        font-weight: bold;
                                        color: white;
                                        background-color: red;
                                        border-radius: 50%;
                                        padding: 10px;
                                        display: inline-flex;
                                        align-items: center;
                                        justify-content: center;
                                    "
                                    >remove</md-icon
                                >
                            </md-button>

                            <md-button
                                @click="showEditMode(inventory)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon>edit</md-icon>
                            </md-button>

                            <md-button
                                @click="showDeleteInventory(inventory.inventory_id)"
                                class="md-raised md-dense md-icon-button md-layout-item"
                            >
                                <md-icon>clear</md-icon>
                            </md-button>
                        </div>
                    </div>
                </md-card-header>

                <md-card-content v-if="inventory.showDetail"> test detail </md-card-content>
            </md-card>
        </div>
        <div>
            <div class="center" v-if="inventoryList?.length > 0">
                <div class="pagination">
                    <div class="page-item">
                        <a aria-label="Previous" class="page-link" @click="setPage(currentPageIndex - 1)">
                            <!--<md-icon>arrow_back_ios</md-icon>-->
                            <template>Prev</template>
                        </a>
                    </div>
                    <!--<li style="align-self: flex-end;" v-if="currentPageIndex > 3">...</li>-->
                    <div v-for="pageNo in maxPages" :key="pageNo" class="page-item">
                        <a
                            v-if="pageNo >= currentPageIndex - 2 && pageNo <= currentPageIndex + 2"
                            class="page-link"
                            v-bind:class="{ active: pageNo === currentPageIndex + 1 }"
                            @click="setPage(pageNo - 1)"
                        >
                            {{ pageNo }}
                        </a>
                    </div>
                    <!--<li style="align-self: flex-end;" v-if="currentPageIndex < maxPages -2">...</li>-->
                    <div class="page-item" v-bind:class="{ disable: currentPageIndex + 1 !== this.maxPages }">
                        <a
                            v-if="currentPageIndex + 1 !== this.maxPages"
                            aria-label="Next"
                            class="page-link"
                            @click="setPage(currentPageIndex + 1)"
                        >
                            <template>Next</template>
                        </a>
                    </div>
                </div>
                <div>
                    <span style="color: #ff9800">
                        {{
                            currentPageSize * (currentPageIndex + 1) -
                            currentPageSize +
                            1 +
                            ' - ' +
                            currentPageSize * (currentPageIndex + 1) +
                            ' of ' +
                            maxPages * currentPageSize
                        }}
                    </span>
                </div>
            </div>
        </div>
        <md-dialog :md-active.sync="showDelete">
            <md-dialog-title>Delete inventory</md-dialog-title>

            <md-dialog-content> Ben je zeker dat je stock wilt verwijderen?</md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="cancelDeleteInventory">No</md-button>
                <md-button class="md-primary" @click="deleteInventory">Yes</md-button>
            </md-dialog-actions>
        </md-dialog>

        <md-dialog :md-active.sync="showIncreaseInv">
            <md-dialog-title>
                <md-icon
                    style="
                        font-weight: bold;
                        color: white;
                        background-color: green;
                        border-radius: 50%;
                        padding: 10px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    "
                    >add</md-icon
                >
                Inventory to increase
            </md-dialog-title>

            <md-dialog-content>
                <md-field>
                    <md-input
                        v-model.number="quantity_to_increase"
                        placeholder="Geef aantal in"
                        type="number"
                        min="0"
                        step="1"
                        required
                    />
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="resetIncreaseInventory">No</md-button>
                <md-button class="md-primary" @click="increaseInventory">Yes</md-button>
            </md-dialog-actions>
        </md-dialog>
        <md-dialog :md-active.sync="showDecreaseInv">
            <md-dialog-title>
                <md-icon
                    style="
                        font-weight: bold;
                        color: white;
                        background-color: red;
                        border-radius: 50%;
                        padding: 10px;
                        display: inline-flex;
                        align-items: center;
                        justify-content: center;
                    "
                    >remove</md-icon
                >
                Inventory to decrease
            </md-dialog-title>

            <md-dialog-content>
                <md-field>
                    <md-input
                        v-model.number="quantity_to_decrease"
                        placeholder="Geef aantal in"
                        type="number"
                        min="0"
                        step="1"
                        required
                    />
                </md-field>
            </md-dialog-content>

            <md-dialog-actions>
                <md-button class="md-primary" @click="resetDecreaseInventory">No</md-button>
                <md-button class="md-primary" @click="decreaseInventory">Yes</md-button>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
import * as toastr from 'toastr';
import router from '@/router';
import ClientSearchModal from '@/components/client-search-modal/ClientSearchModal.vue';
import HourDisplay from '@/components/utils/HourDisplay.vue';
import { InventoryApi, IProductEntity } from '@phrospr/api-backend';
import StarRating from 'vue-star-rating';
import {
    IInventoryEntity,
    IInventoryExtendedEntity,
    IInventorySearchEntity,
    IInventorySearchFilterEntity,
} from '@phrospr/lib-models';
import deleteInventory = InventoryApi.deleteInventory;
import ProductSearchModal from '@/components/product-search-modal/ProductSearchModal.vue';

export interface InventoryOverView extends IInventoryExtendedEntity {
    showDetail?: boolean;
}

@Component({
    methods: { deleteInventory },
    components: {
        ProductSearchModal,
        ClientSearchModal,
        HourDisplay,
        StarRating,
    },
    beforeRouteEnter: async function (to, from, next) {
        try {
            next((component: InventoryOverview) => component.setPage(0));
        } catch (err) {
            console.error(err);
        }
    },
})
export default class InventoryOverview extends Vue {
    inventoryList: Array<InventoryOverView> = [];

    inventorySearchCore: IInventorySearchEntity = {
        limit: 10,
        offset: 10,
        show: {
            product: true,
            location: true,
        },
    };

    inventorySearchFilter: IInventorySearchFilterEntity = {
        product_name: '',
        product_number: '',
        location_name: '',
    };

    currentPageSize = 10;
    currentPageIndex = 1;
    maxPages = 1;

    showDelete: boolean = false;
    inventoryIdToDelete: number;

    showIncreaseInv: boolean = false;
    inventoryIdToIncreaseInv: number;
    quantity_to_increase: number;

    showDecreaseInv: boolean = false;
    inventoryIdToDecreaseInv: number;
    quantity_to_decrease: number;

    constructor() {
        super();
    }

    searchInventory(resetSearch?: boolean, product?: IProductEntity) {
        this.setPage(0);
        if (product) {
            this.inventorySearchFilter.product_name = product.name;
        }
        if (resetSearch) {
            this.inventorySearchFilter.product_name = '';
        }
        this.getInventory(
            this.inventorySearchFilter.location_name,
            this.inventorySearchFilter.product_number,
            this.inventorySearchFilter.product_name,
            this.inventorySearchCore,
        );
    }

    public async getInventory(
        product_name?: string,
        product_number?: string,
        location_name?: string,
        inventorySearchCore?: IInventorySearchEntity,
    ) {
        try {
            const inventory = await InventoryApi.getInventoryListPost({
                inventory_filter: inventorySearchCore,
            });

            this.inventoryList = inventory.data.records;
            this.maxPages = Math.ceil(inventory.data.total / this.currentPageSize);
        } catch (e) {
            console.log(e);
            toastr.error('Something went wrong with server call to retrieve the inventory');
        }
    }

    showDeleteInventory(inventory_id: number) {
        this.showDelete = true;
        this.inventoryIdToDelete = inventory_id;
    }

    cancelDeleteInventory() {
        this.showDelete = false;
        this.inventoryIdToDelete = null;
    }

    public async deleteInventory() {
        try {
            await InventoryApi.deleteInventory(this.inventoryIdToDelete);
            this.showDelete = false;
            this.setPage(this.currentPageIndex);
        } catch (e) {
            toastr.error('Something went wrong with server call');
        }
    }

    public showEditMode(inventory: IInventoryEntity) {
        return router.push({ path: `/inventory/upsert/${inventory.inventory_id}` });
    }

    public showIncreaseInvMode(inventory_id: number) {
        this.showIncreaseInv = true;
        this.inventoryIdToIncreaseInv = inventory_id;
    }

    public async increaseInventory() {
        console.log(typeof this.quantity_to_increase);
        try {
            await InventoryApi.increaseInventory({
                inventory_id: this.inventoryIdToIncreaseInv,
                quantity_to_increase: this.quantity_to_increase,
            });
            this.resetIncreaseInventory();
            this.setPage(this.currentPageIndex);
        } catch (e) {
            toastr.error('Something went wrong with server call');
        }
    }

    resetIncreaseInventory() {
        this.showIncreaseInv = false;
        this.inventoryIdToIncreaseInv = null;
        this.quantity_to_increase = null;
    }

    public showDecreaseInvMode(inventory_id: number) {
        this.showDecreaseInv = true;
        this.inventoryIdToDecreaseInv = inventory_id;
    }

    public async decreaseInventory() {
        try {
            await InventoryApi.decreaseInventory({
                inventory_id: this.inventoryIdToDecreaseInv,
                quantity_to_decrease: this.quantity_to_decrease,
            });
            this.resetDecreaseInventory();
            this.setPage(this.currentPageIndex);
        } catch (e) {
            toastr.error(
                'Something went wrong with server call. Perhaps you are trying to decrease more then what is available in stock',
            );
        }
    }

    resetDecreaseInventory() {
        this.showDecreaseInv = false;
        this.inventoryIdToDecreaseInv = null;
        this.quantity_to_decrease = null;
    }

    public async showCreateNewInventory() {
        await router.push({ path: '/inventory/upsert' });
    }

    public async setPage(pageIndex: number) {
        if (pageIndex < 0) return;
        if (pageIndex > this.maxPages - 1 && pageIndex < 0)
            return console.log('page to high', pageIndex, this.maxPages);
        this.currentPageIndex = pageIndex;

        this.inventorySearchCore = {
            ...this.inventorySearchCore,
            limit: this.currentPageSize,
            offset: this.currentPageSize * this.currentPageIndex,
            filter: this.inventorySearchFilter,
        };

        await this.getInventory(
            this.inventorySearchCore?.filter?.product_name,
            this.inventorySearchCore?.filter?.product_number,
            this.inventorySearchCore?.filter?.location_name,
            this.inventorySearchCore,
        );
    }
}
</script>

<style scoped>
.align-right {
    text-align: right;
}

.md-badge {
    position: relative;
}

.work_order-edit-disabled.md-button {
    background: rgba(0, 0, 0, 0.1);
}

.md-button[disabled] {
    opacity: 0.5;
}

.md-card-header {
    padding: 8px;
}

.center {
    text-align: center;
    width: 100%;
}

.pagination {
    border-radius: 0.25rem;
    display: inline-flex;
    padding: 2px;
}

.page-link {
    position: relative;
    display: block;
    padding: 0.5rem 0.75rem;
    margin-left: 0;
    line-height: 1.25;
    color: #2196f3;
    background-color: transparent;
    border: 0 solid #dee2e6;
    cursor: pointer;
}

.pagination a span {
    border: 0;
    transition: all 0.3s;
    margin: 0 3px;
    padding: 0;
    min-width: 30px;
    height: 30px;
    line-height: 30px;
    text-transform: uppercase;
    background: transparent;
    text-align: center;
    cursor: pointer;
}

.pagination a.active {
    border-radius: 30px !important;
    background-color: #ff9800;
    border-color: #ff9800;
    color: #fff !important;
    box-shadow: 0 4px 5px 0 rgba(255, 152, 0, 0.14), 0 1px 10px 0 rgba(255, 152, 0, 0.12),
        0 2px 4px -1px rgba(255, 152, 0, 0.2);
}
</style>
